import { ContactDetailsService } from '../contact-details.service';
import { BehaviorSubject } from 'rxjs';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import * as i0 from "@angular/core";
import * as i1 from "../contact-details.service";
var SearchDirection = {
    BEFORE: 'BEFORE',
    AFTER: 'AFTER'
};
var HistoryService = /** @class */ (function () {
    function HistoryService(contactDetailsService) {
        this.contactDetailsService = contactDetailsService;
        this.limit = 5;
        this.onUpdateHistory = new BehaviorSubject(opener);
    }
    HistoryService.prototype.loadHistory = function (contactId, contactEventId, limit, searchType) {
        var _this = this;
        if (limit === void 0) { limit = this.limit; }
        if (searchType === void 0) { searchType = ''; }
        this.contactDetailsService
            .getContactHistory({
            contactId: contactId,
            eventId: contactEventId,
            limit: limit,
            type: searchType
        })
            .subscribe(function (res) {
            _this.addToListingBefore(res);
        });
    };
    HistoryService.prototype.setValues = function (searchType, history) {
        this.searchType = searchType;
        this.history = history;
    };
    HistoryService.prototype.addToListingBefore = function (historyList) {
        this.totalHistoryEventsBefore = historyList.length;
        this.history = this.history.concat(historyList);
        this.getHistory(this.history);
    };
    HistoryService.prototype.addToListingAfter = function (historyList) {
        this.totalHistoryEventsAfter = historyList.length;
        this.history = historyList.concat(this.history);
        this.getHistory(this.history);
    };
    HistoryService.prototype.chooseType = function (type, contactId, eventId) {
        this.setValues(type, []);
        this.loadHistory(contactId, eventId, this.limit, type);
    };
    HistoryService.prototype.getHistory = function (historyList) {
        this.onUpdateHistory.next(historyList);
    };
    HistoryService.prototype.refreshHistory = function (contactId, contactEventId) {
        if (contactEventId === void 0) { contactEventId = null; }
        this.history = [];
        this.totalHistoryEventsAfter = this.totalHistoryEventsBefore = null;
        this.loadHistory(contactId, contactEventId);
    };
    HistoryService.prototype.prependHistory = function (contactId) {
        var _this = this;
        this.contactDetailsService
            .getContactHistory({
            contactId: contactId,
            eventId: this.history[0].id,
            limit: this.limit,
            searchDirection: SearchDirection.AFTER,
            type: this.searchType
        })
            .subscribe(function (res) {
            _this.addToListingAfter(res);
        });
    };
    HistoryService.prototype.appendHistory = function (contactId) {
        var _this = this;
        this.contactDetailsService
            .getContactHistory({
            contactId: contactId,
            eventId: this.history[this.history.length - 1].id,
            limit: this.limit,
            searchDirection: SearchDirection.BEFORE,
            type: this.searchType
        })
            .subscribe(function (res) {
            _this.addToListingBefore(res);
        });
    };
    HistoryService.prototype.isAvailableMoreHistoryAfter = function () {
        return this.totalHistoryEventsAfter === null || this.totalHistoryEventsAfter >= this.limit;
    };
    HistoryService.prototype.isAvailableMoreHistoryBefore = function () {
        return this.totalHistoryEventsBefore === null || this.totalHistoryEventsBefore >= this.limit;
    };
    HistoryService.prototype.getIsoCountry = function (number) {
        var parsedNumber = parsePhoneNumberFromString(number);
        return parsedNumber && parsedNumber.country.toLowerCase();
    };
    HistoryService.ngInjectableDef = i0.defineInjectable({ factory: function HistoryService_Factory() { return new HistoryService(i0.inject(i1.ContactDetailsService)); }, token: HistoryService, providedIn: "root" });
    return HistoryService;
}());
export { HistoryService };
